import { Link } from '@bedrock/components';
import { ProText } from '@bedrock/eed-react';
import { EllipsisTooltip } from '@mpc/components';
import { FormEnvContext } from '@purchase/supplier';
import React, { useContext } from 'react';
import { FC } from 'react';

export const ProLink: FC<{ ellipsis?: boolean }> = ({ ellipsis, ...props }) => {
  const { collapsed } = useContext(FormEnvContext) || {};

  const render = (value: any) => {
    if (!value) return '-';
    const linkContent = (
      <Link type="primary" href={value} target="_blank">
        {value}
      </Link>
    );
    if (collapsed || ellipsis) {
      return <EllipsisTooltip clamp={1} text={linkContent} />;
    }
    return linkContent;
  };
  return <ProText {...props} fieldProps={{}} render={render} />;
};
